import type { RouteRecordRaw } from 'vue-router';

export const CATEGORY_ROUTER: RouteRecordRaw = {
  path: '/admin/category',
  component: () => import('@/modules/admin/category/views/Categories.vue'),
  name: 'Category',
  meta: {
    title: '카테고리 관리',
    requiresAuth: true,
  },
};
